export default class AlContactSelectorController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');

        this.onContactSelect = () => {
        };

        this.models = {
            contact_id: null
        };

        this.disabledStates = {
            contacts: true
        }

        this.items = {
            contacts: []
        }

        this._initSelectizeOptions();
    }

    $onInit() {
        this._loadContacts();
    }

    handleContactChange(value) {
        if (!value) {
            this.models.contact_id = _.get(_.first(this.items.contacts), 'value', null);
        } else {
            this.models.contact_id = _.cloneDeep(value);
        }

        this.onContactSelect({
            contactId: this.models.contact_id ? parseInt(this.models.contact_id) : null
        });
        this.scope.$applyAsync();
    }

    _initSelectizeOptions() {
        this.selectizeOptions = {
            contacts: {
                maxItems: 1,
                placeholder: this.translate.instant('general.verbs.loading') + '...'
            }
        }
    }

    _loadContacts() {
        this.api
            .post(`fp/contacts`, {
                sort: {
                    full_name: 'asc'
                },
                filters: [
                    {
                        field: 'addressbook',
                        operator: '=',
                        value: true
                    }
                ],
                pagination: {
                    perPage: -1
                },
                fields: [
                    'full_name',
                    'id'
                ]
            })
            .then(({data}) => {
                this.items.contacts = _.map(data.data, (guestlist) => ({
                    value: guestlist.id,
                    label: guestlist.full_name
                }));
                this.models.contact_id = _.get(_.first(data.data), 'id', null);

                this.disabledStates.contacts = false;

                this.scope.$applyAsync();
            })
    }
}

AlContactSelectorController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/contacts/components/al-contact-selector/controller.js